import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { useThemeMode } from '../../../../_metronic/partials'

const UpdateScoreModal = ({ isActive, setIsActive }: any) => {
    const { formatMessage } = useIntl()
    const { mode } = useThemeMode()
    const [changeScore, setChangeScore] = useState('')
    return (
        <div>
            <Modal show={isActive} onHide={() => setIsActive()} size="sm">
                <Modal.Header closeButton>
                    <h2>
                        {formatMessage({ id: 'Update Score' })}
                    </h2>
                </Modal.Header>
                <Modal.Body className='container'>
                    <div className='rounded p-4 d-flex align-items-center justify-content-center flex-column gap-4' style={{ background: mode === 'dark' ? '#45465A' : '#EFF6FF', border: '1px solid rgba(13, 33, 109, 0.4)' }}>
                        <p className='mb-0 font-size-14 text-dark'>{formatMessage({ id: 'Current Score' })}</p>
                        <h1 className='mb-0 font-size-24 text-primary'>{formatMessage({ id: '60' })}</h1>
                        <input placeholder='Enter New Score' type='number' value={changeScore} onChange={(e) => setChangeScore(e.target.value)} className='p-4 text-center rounded border border-secondary border-2 w-100 ' />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-md-flex w-100 w-md-auto justify-content-end px-0 gap-3'>
                        <div className='w-100 order-1 order-md-2 mb-2 mb-md-auto'>
                            <button
                                type='submit'
                                className='btn bg-primary text-white custom-button-property w-100'
                            // onClick={getPortalLink}
                            >
                                {/* {loading ? (
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        {formatMessage({ id: 'Please wait' })}...{' '}
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    </span>
                                ) : ( */}
                                <span className='indicator-label'>{formatMessage({ id: 'Update' })}</span>
                                {/* )} */}
                            </button>
                        </div>
                        <div className='w-100 w-md-auto order-2 order-md-1'>
                            <button
                                type='button'
                                className='btn bg-light text-muted custom-button-property w-100'
                                onClick={() => setIsActive(!setIsActive)}
                            >
                                {formatMessage({ id: 'Cancel' })}
                            </button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default UpdateScoreModal
